import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { ProductModulesBody } from "../productModulesBody";

/**
 * sealy ProductLineCollectionPage `modules` body assembly (#33285), rendered
 * inside the full-document ProductLineCollectionPageTemplate; see
 * `productModulesBody.tsx` for the dispatch map and side-channel design.
 *
 * FAITHFUL port of the second legacy `cms/product_line_collection_page.html`
 * loop (verified at git dev):
 *
 *     {% for block in self.modules %}
 *         {% if block.block_type != "gallery_block" %}
 *             <div class="block-{{ block.block_type }}">
 *                 {% include_block block %}
 *             </div>
 *         {% endif %}
 *     {% endfor %}
 *
 * i.e. every NON-gallery module (top-level `gallery_block` renders in the
 * separate hero assembly, reproduced by the `.filter()` below), each
 * hand-wrapped in `<div class="block-{{ block.block_type }}">` -- the
 * `wrapBlocks` mode of the shared assembly (load-bearing: the sealy
 * `_toolbox-overrides.scss` targets `#product-detail`'s `.block-*` children,
 * which only the PLC page produces). Unlike the PLP, the legacy PLC body had
 * NO `{% cache %}` wrapper, so none is added.
 */
export const ProductLineCollectionBody = (
    props: Immutable<
        Pick<
            templates.ProductLineCollectionPageTemplate,
            | "page"
            | "reviews"
            | "page_num_reviews"
            | "change_variant_ssr"
            | "change_root_ssr"
            | "root_conditional_ssr"
            | "variant_conditional_ssr"
            | "tab_cards_initial_root_product_id"
        >
    >,
): React.JSX.Element | null => {
    const modules = props.page.modules;
    if (!modules) {
        return null;
    }
    return (
        <ProductModulesBody
            value={modules.value.filter(
                (block) => block.type !== "gallery_block",
            )}
            wrapBlocks
            reviews={props.reviews}
            pageNumReviews={props.page_num_reviews}
            changeVariantSSR={props.change_variant_ssr}
            changeRootSSR={props.change_root_ssr}
            rootConditionalSSR={props.root_conditional_ssr}
            variantConditionalSSR={props.variant_conditional_ssr}
            tabCardsInitialRootProductID={
                props.tab_cards_initial_root_product_id
            }
        />
    );
};
